/**
 * Use a stub for MaskedView on all Platforms that don't support it.
 */

export default function MaskedView(_ref) {
  let {
    children
  } = _ref;
  return children;
}
//# sourceMappingURL=MaskedView.js.map